/* Collection sorting policy. Shopify applies the filter before pagination. */
(function (root) {
  const availabilityKey = 'filter.v.availability';

  function normalize(search, config, intent = 'navigate') {
    if (!config || !config.enabled) return search;
    const params = new URLSearchParams(search);
    const before = params.toString();
    const sort = params.get('sort_by');
    const customSort = sort && sort !== 'manual';
    const values = params.getAll(availabilityKey).flatMap(value => value.split(','));
    const availableOnly = values.length === 1 && values[0] === '1';
    const soldOutOnly = values.length === 1 && values[0] === '0';

    // These five reviewed collections cannot use Shopify's native filters.
    if (config.recommendedOnly) {
      if (customSort) {
        params.set('sort_by', 'manual');
        params.delete('page');
      }
      params.delete(availabilityKey);
      return params.toString() === before ? search : params.toString();
    }
    if (!config.filterSupported) return search;

    if (intent === 'sort') {
      params.set(availabilityKey, '1');
      params.delete('page');
    } else if (customSort && !availableOnly && !soldOutOnly) {
      if (intent === 'remove' || intent === 'availability' || values.length > 0) {
        // Explicitly broadening availability returns to the app's manual order.
        params.set('sort_by', 'manual');
      } else {
        // Shared/bookmarked sort URLs get the same protection as the dropdown.
        params.set(availabilityKey, '1');
      }
      params.delete('page');
    }
    return params.toString() === before ? search : params.toString();
  }

  function configFromDocument() {
    const form = root.document?.querySelector('facet-filters-form[data-availability-sorting]');
    return form ? {
      enabled: true,
      filterSupported: form.dataset.availabilityFilter === 'true',
      recommendedOnly: form.dataset.recommendedOnly === 'true',
    } : null;
  }

  const api = { normalize, configFromDocument };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.CollectionAvailability = api;

  if (root.document) {
    const current = root.location.search.slice(1);
    const normalized = normalize(current, configFromDocument());
    if (normalized !== current) {
      root.location.replace(`${root.location.pathname}?${normalized}${root.location.hash}`);
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
